import { createActionGroup, emptyProps } from '@ngrx/store';
import { DataOutsideEUResponse, UsageChart } from '@core/models';
import {
  BillingResponse,
  CommunicationRequest,
  CommunicationResponse,
  CustomerInvoiceResponse,
  NetworkSettingsRequest,
  NetworkSettingsResponse,
  NewSubscriptionsResponse,
  PrivacyResponse,
} from '@core/contracts/data-contracts';

export const GeneralActions = createActionGroup({
  source: 'General',
  events: {
    'Overview Get Usage Details': emptyProps(),
    'Overview Get Usage Details Success': (usageChart: UsageChart) => ({
      usageChart,
    }),
    'Overview Get Usage Details Failure': emptyProps(),
    'Overview Clear Usage Details': emptyProps(),

    'Pay invoice': (invoiceId: string) => ({ invoiceId }),
    'Pay invoice Success': emptyProps(),
    'Pay invoice Failure': emptyProps(),

    'Get All Invoices': emptyProps(),
    'Get All Invoices Success': (allInvoices: CustomerInvoiceResponse[]) => ({
      allInvoices,
    }),
    'Get All Invoices Failure': emptyProps(),

    'Get Paid Invoices': emptyProps(),
    'Get Paid Invoices Success': (paidInvoices: CustomerInvoiceResponse[], totalItems: number) => ({
      paidInvoices,
      totalItems,
    }),
    'Get Paid Invoices Failure': emptyProps(),

    'Get Outstanding Invoices': emptyProps(),
    'Get Outstanding Invoices Success': (outstandingInvoices: CustomerInvoiceResponse[]) => ({
      outstandingInvoices,
    }),
    'Get Outstanding Invoices Failure': emptyProps(),

    'Get Specification Invoice Pdf': (number: string) => ({ number }),
    'Get Specification Invoice Pdf Success': emptyProps(),
    'Get Specification Invoice Pdf Failure': emptyProps(),

    'Get Invoice Pdf': (number: string) => ({ number }),
    'Get Invoice Pdf Success': emptyProps(),
    'Get Invoice Pdf Failure': emptyProps(),

    'Get Ad Preferences': emptyProps(),
    'Get Ad Preferences Success': (adPreferences: CommunicationResponse) => ({
      adPreferences,
    }),
    'Get Ad Preferences Failure': emptyProps(),
    'Update Ad Preferences': (payload: CommunicationRequest) => ({
      payload,
    }),
    'Update Ad Preferences Success': (payload: CommunicationRequest) => ({
      payload,
    }),
    'Update Ad Preferences Failure': emptyProps(),

    'Get Privacy Settings': emptyProps(),
    'Get Privacy Settings Success': (privacySettings: PrivacyResponse) => ({
      privacySettings,
    }),
    'Get Privacy Settings Failure': emptyProps(),

    'Get Sim Card Type': emptyProps(),
    'Get Sim Card Type Success': (simCardType: number) => ({
      simCardType,
    }),
    'Get Sim Card Type Failure': emptyProps(),

    'Get Puk Code': emptyProps(),
    'Get Puk Code Success': (pukCode: string) => ({
      pukCode,
    }),
    'Get Puk Code Failure': emptyProps(),
    'Clear Puk Code': emptyProps(),

    'Replace Sim Card': (isEsim: boolean) => ({
      isEsim,
    }),
    'Replace Sim Card Success': emptyProps(),
    'Replace Sim Card Failure': emptyProps(),

    'Get Esim Data': emptyProps(),
    'Get Esim Data Success': (
      convertedProfile: string,
      activationCode: string,
      smdpAddress: string
    ) => ({
      convertedProfile,
      activationCode,
      smdpAddress,
    }),
    'Get Esim Data Failure': emptyProps(),

    'Block Sim Card': emptyProps(),
    'Block Sim Card Success': emptyProps(),
    'Block Sim Card Failure': emptyProps(),

    'Unblock Sim Card': emptyProps(),
    'Unblock Sim Card Success': emptyProps(),
    'Unblock Sim Card Failure': emptyProps(),

    'Activate Sim Card': emptyProps(),
    'Activate Sim Card Success': emptyProps(),
    'Activate Sim Card Failure': emptyProps(),

    'Get Bank Account Info': emptyProps(),
    'Get Bank Account Info Success': (bankAccountInfo: BillingResponse) => ({
      bankAccountInfo,
    }),
    'Get Bank Account Info Failure': emptyProps(),

    'Request Change Bank Account': emptyProps(),
    'Request Change Bank Account Success': (url: string) => ({
      url,
    }),
    'Request Change Bank Account Failure': emptyProps(),

    'Get Available Subscriptions': emptyProps(),
    'Get Available Subscriptions Success': (availableSubscriptions: NewSubscriptionsResponse) => ({
      availableSubscriptions,
    }),
    'Get Available Subscriptions Failure': emptyProps(),

    'Get Data Outside EU': emptyProps(),
    'Get Data Outside EU Success': (tariffs: DataOutsideEUResponse) => ({
      tariffs,
    }),
    'Get Data Outside EU Failure': emptyProps(),

    'Get Network Settings': emptyProps(),
    'Get Network Settings Success': (networkSettings: NetworkSettingsResponse) => ({
      networkSettings,
    }),
    'Get Network Settings Failure': emptyProps(),
    'Update Network Settings': (payload: NetworkSettingsRequest) => ({
      payload,
    }),
    'Update Network Settings Success': (payload: NetworkSettingsRequest) => ({
      payload,
    }),
    'Update Network Settings Failure': emptyProps(),

    'Get Privacy Pdf': emptyProps(),
    'Get Privacy Pdf Success': emptyProps(),
    'Get Privacy Pdf Failure': emptyProps(),

    'Get Storage Price': emptyProps(),
    'Get Storage Price Success': (price: number) => ({
      price,
    }),
    'Get Storage Price Failure': emptyProps(),
  },
});
